module.exports = __webpack_public_path__ + "img/acabado_pulido.2e82716b.png";